import React, {useEffect, useState, Fragment} from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import { withRouter } from "react-router-dom";

import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

import {getFeatureGroupName} from "../../../../../misc/helpers";
import LookViewTypeSwitcher from "../lookViewTypeSwitcher";
import {setLookActiveCategory, setLookActiveFeature} from "../../../../../actions/lookFunctions";
import LookCanvasContext from "../../../lookCanvasContext";
import {zoomCanvasOut} from "../../lookFunctions";
import {setCanvasScale} from "../../../../../actions/actionFunctions";
import {getFeatureParent, getLookIdUrl} from "../../lookFunctions2";
import LookMainHeaderCloseButton from "../lookMainHeaderCloseButton";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";
import {pricingIsLocked} from "../../lookNavigationFunctions";
import LookFeatureRevertButton from "../lookFeature/lookFeatureRevertButton";
// import LookFeatureMatchingStyleAlert from "../lookFeature/lookFeatureMatchingStyleAlert";

const LookCategoryHeader = (props) => {

  const {intl, activeFeatureId, lookActiveFeature, fabricatorData, history, isMobile, setLookActiveCategory,
    setLookActiveFeature, setCanvasScale, lookActiveCategory} = props;

  const [featureGroupName, setFeatureGroupName] = useState("");

  useEffect(() => {
    if (lookActiveFeature || lookActiveCategory) {
      const featureGroup = getFeatureParent(lookActiveFeature, lookActiveCategory);
      setFeatureGroupName(getFeatureGroupName(featureGroup, intl, fabricatorData));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeFeatureId, lookActiveCategory]);

  const backButtonClick = (imageCanvas) => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookMenuHeaderBack);
    setLookActiveCategory("");
    setLookActiveFeature(null);
    zoomCanvasOut(imageCanvas, setCanvasScale);
    history.push(getLookIdUrl());
  };

  const {pricingLocked} = pricingIsLocked();
  const showSelectWord = (featureGroupName || "").length <= 12;

  return (
    <LookCanvasContext.Consumer>
      {(imageCanvas) => (
        <Fragment>
          <div className="lm-header__back">
            <IconButton aria-label={intl.formatMessage({id:"iconButton.back"})}
                        className={"look-icon" + (isMobile ? "" : " look-icon--white look-icon--small")}
                        onClick={() => backButtonClick(imageCanvas)}>
              <ChevronLeftIcon/>
            </IconButton>
            <span className="lm-header__title" onClick={() => backButtonClick(imageCanvas)}>
              {showSelectWord ? <Fragment><FormattedMessage id="look.feature.select"/> </Fragment> : null}{featureGroupName}
            </span>
          </div>
          <div className="lm-header__buttons">
            {pricingLocked ? null : <LookViewTypeSwitcher/>}
            {isMobile ? null : (
              <LookMainHeaderCloseButton/>
            )}
            {isMobile ? <LookFeatureRevertButton/> : null}
          </div>
          {/*{isMobile && lookActiveFeature ? <LookFeatureMatchingStyleAlert lookFeature={lookActiveFeature}/> : null}*/}
        </Fragment>
      )}
    </LookCanvasContext.Consumer>
  )
};

const mapStateToProps = (store) => {
  const {lookActiveFeature, lookViewType, lookActiveCategory} = store.lookState;
  const {isMobile} = store.serverState;
  const {isPhoneNumberValidated} = store.userState; // to update component when user is logged in

  return {
    isMobile,
    lookActiveFeature,
    lookViewType,
    activeFeatureId: lookActiveFeature ? lookActiveFeature.dbFeature.id : "",
    fabricatorData: store.fabricatorState,
    lookActiveCategory,
    isPhoneNumberValidated,
  };
};

const mapDispatchToProps = {
  setLookActiveCategory,
  setLookActiveFeature,
  setCanvasScale,
};

export default withRouter(
  injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(LookCategoryHeader)
  )
)
